export enum WalletType {
	EpicWalletSupported = 'EpicWalletSupported',
	EpicWalletUnsupported = 'EpicWalletUnsupported'
}

export enum RewardType {
	EpicRewardsSupported = 'EpicRewardsSupported',
	EpicRewardsUnsupported = 'EpicRewardsUnsupported'
}

interface WalletBalanceSupported {
	__typename: WalletType.EpicWalletSupported;
	balance: string;
}

interface WalletBalanceUnsupported {
	__typename: WalletType.EpicWalletUnsupported;
}

type WalletBalance = WalletBalanceSupported | WalletBalanceUnsupported;

interface EpicRewardsBalanceSupported {
	__typename: RewardType.EpicRewardsSupported;
	balance: string;
	rawBalance: number;
}

interface EpicRewardsBalanceUnsupported {
	__typename: RewardType.EpicRewardsUnsupported;
}

type EpicRewardsBalance = EpicRewardsBalanceSupported | EpicRewardsBalanceUnsupported;

export interface CouponsBalance {
	count: number;
}

export interface WalletResource {
	wallet: WalletBalance;
	epicRewards: EpicRewardsBalance;
	coupons: CouponsBalance;
}
